'use client';

import { Dialog, DialogBackdrop, DialogPanel, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import type { UiModalProps } from './UiModal.types';
import { modalStyles } from './UiModal.styles';
import { cn } from '@/lib/utils/tw-merge';
import { UiIcon } from '@/components/ui/UiIcon';

function UiModal({
    open,
    children,
    hideClose,
    bare = false,
    onClose,
    onClosed,
    size = '2xs',
    className,
    containerClassName,
    panelClassName,
    backdropClassName,
    closeButtonClassName,
    closeButtonIconClassName,
    closeButtonLabel = 'Close',
    closeButtonPosition = 'top-right',
    appear = false,
    ...props
}: UiModalProps) {
    const close = () => onClose?.(false);

    return (
        <Transition as={Fragment} show={open} appear={appear} afterLeave={onClosed}>
            <Dialog onClose={onClose} className={cn(modalStyles.base, className)} {...props}>
                <div className={cn(modalStyles.container, containerClassName)}>
                    <DialogBackdrop transition className={cn(modalStyles.backdrop, backdropClassName)} />
                    <DialogPanel
                        transition
                        className={cn(
                            modalStyles.panel,
                            !bare && modalStyles.panelLook,
                            modalStyles.sizes[size],
                            panelClassName,
                        )}
                    >
                        {!hideClose && (
                            <button
                                type="button"
                                onClick={close}
                                className={cn(
                                    modalStyles.closeButton,
                                    modalStyles.closeButtonPositions[closeButtonPosition],
                                    closeButtonClassName,
                                )}
                                aria-label={closeButtonLabel}
                            >
                                <UiIcon
                                    name="x-mark"
                                    className={cn('size-6.5', closeButtonIconClassName)}
                                    aria-hidden="true"
                                />
                            </button>
                        )}

                        {children}
                    </DialogPanel>
                </div>
            </Dialog>
        </Transition>
    );
}

export default UiModal;
